<div mat-dialog-title>
<!--  <div class="dialog-caption">About tank</div>-->
  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div class="flex-column align-h-center" mat-dialog-content>
  <iframe [src]="('https://www.youtube-nocookie.com/embed/' + data.videoId + '?autoplay=1&rel=0&cc_load_policy=0') | safeUrl"
          allow="autoplay; encrypted-media; fullscreen"
          class="w-100 h-100 ratio-16x9"
          frameborder="0">
  </iframe>
<!--  <div class="ph-10 text-left">-->
<!--    <h5 class="mb-15 text-center text-uppercase">{{ data.description }}</h5>-->

<!--    <div class="d-inline-block h7 mh-0">-->
<!--      <div *ngFor="let feature of data.features" class="d-flex">-->
<!--        <i class="icon-check ic-success mh-10"></i>-->
<!--        <div>{{ feature }}</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</div>
